import { produce } from 'immer'
import { State } from '../typings'
import { ServiceLocation } from '@user/store/entityLocations'

export type SelectPrimaryServiceLocationAction = {
  type: 'selectPrimaryServiceLocation'
  payload?: ServiceLocation
}

type SelectPrimaryServiceLocationActionCreator = (
  payload: SelectPrimaryServiceLocationAction['payload'],
) => SelectPrimaryServiceLocationAction

export const selectPrimaryServiceLocation = produce<
  State,
  [SelectPrimaryServiceLocationAction['payload']]
>((draft, payload) => {
  draft.loading = !!payload

  draft.primaryServiceLocation = payload
  draft.serviceLocations = []

  draft.selectedServiceLocations = new Map()
  if (!!payload) draft.selectedServiceLocations.set(payload.id, payload)
  else draft.appliedSelections = undefined
})

export const selectPrimaryServiceLocationActionCreator: SelectPrimaryServiceLocationActionCreator =
  (payload) => ({
    type: 'selectPrimaryServiceLocation',
    payload,
  })
